import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  id: "state",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27.904 25.017",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Tracé_78",
      "data-name": "Tracé 78",
      d: "M25.442,67.244a1.439,1.439,0,0,0,1.021-.423l8.12-8.12,3.309,3.309a1.443,1.443,0,0,0,2.041,0l9.082-9.082v3.25a1.443,1.443,0,1,0,2.887,0V49.443A1.443,1.443,0,0,0,50.459,48H43.724a1.443,1.443,0,0,0,0,2.887h3.251l-8.062,8.062L35.6,55.639a1.443,1.443,0,0,0-2.041,0L24.421,64.78a1.443,1.443,0,0,0,1.021,2.464Z",
      transform: "translate(-23.998 -48)"
    }, null, -1),
    _createElementVNode("path", {
      id: "Tracé_79",
      "data-name": "Tracé 79",
      d: "M50.46,416H25.443a1.443,1.443,0,1,0,0,2.887H50.46a1.443,1.443,0,1,0,0-2.887Z",
      transform: "translate(-24 -393.869)"
    }, null, -1)
  ])))
}